<template>
  <div class="expert">
    <div v-if="isPending" class="expert__loading">
      <div class="ws-list-view-skeleton">
        <ws-list-view-skeleton-item
          :height="'30px'"
          :boxCount="1"
          :boxHeights="['30px']"
        />
        <ws-list-view-skeleton-item
          :height="'25px'"
          :boxCount="1"
          :boxHeights="['25px']"
        />
      </div>
    </div>
    <template v-else>
      <div class="ws-members__list" v-if="expert.guid && expert.guid !== nullGuid">
        <div class="ws-members__item ws-members__item--upt ws-member">
        <div class="ws-member__column">
            <figure class="image is-128x128">
              <ws-avatar
                :id="expert.guid"
                :name="getExpertName()"
                :size="128"
                />
            </figure>
        </div>
        <div class="ws-member__column">
          <span>
            <strong>{{ getExpertName(true) }}</strong><br>
            <span class="is-size-5">{{ expert.region ? expert.region.title.display : '' }}</span><br>
            <span>{{ expert.phoneNumbers }}</span><br>
            <span class="has-text-primary">{{ expert.email }}</span><br>
            <ws-demo-exams-certificate-view :exam_day_cm1="exam.day_cm1" :expert="expert" expertType="mainExpert" />
            <b-checkbox
              name="remote"
              class="b-checkbox__centered"
              @input="onRemoteChange"
              :disabled="isRemotePending"
              v-if="isRemoteExam"
              v-model="isRemote"
            >
              <b>{{$t('Дистанционный (удаленный) формат')}}</b> <ws-spinner v-if="isRemotePending" />
            </b-checkbox>
          </span>
        </div>
        <div class="ws-member__column">
        </div>
        <div v-if="expert.isNotLocal" class="ws-member__column" style="padding-right: 20px">
            <div class="buttons">
              <ws-permission-node :resources="['services/de/mainexpert']" :actions="['update']" effect="display">
                  <!-- TODO Разграничить права на добавдение/редактирование экспертов на бэке-->
                  <ws-role-node :except="['front_university', 'front_curator_institution']">
                    <b-tooltip :active="disabledChangeMainExpertStatus" style="width: 100%;" label="Отсутствуют необходимые документы" type="is-dark">
                      <template v-slot:content>
                        <span class="has-text-danger">Отсутствуют необходимые документы</span>
                      </template>
                      <button
                        v-if="getShowButton(buttonsNames.assign)"
                        type="button" class="ws-button button is-primary is-small is-uppercase is-fullwidth"
                        @click="changeMainExpertStatus(expertStatus.accepted)"
                        :class="{'is-loading':isMainExpertStatusPending || isRejecting}"
                        v-text="$t('Назначить')"
                        :disabled="disabledChangeMainExpertStatus || !isMyDeCenter"
                      ></button>
                    </b-tooltip>
                    <button
                      v-if="getShowButton(buttonsNames.appointment_unavailable)"
                      type="button" class="ws-button button is-danger is-small is-uppercase is-fullwidth"
                      disabled
                      v-text="$t('Назначение недоступно')"
                    ></button>

                    <button

                      v-if="getShowButton(buttonsNames.reject)"
                      type="button" class="ws-button button is-primary is-small is-uppercase is-fullwidth"
                      @click="onMainExpertRejection(expertStatus.rejected)"
                      :class="{'is-loading':isMainExpertStatusPending || isRejecting}"
                      :disabled="!isMyDeCenter"
                      v-text="$t('Отклонить')"
                    ></button>

                    <button type="button" class="ws-button button is-primary is-small is-uppercase is-fullwidth"
                      v-if="getShowButton(buttonsNames.reject_ticket)"
                      @click="onMainExpertRejectionWithReason"
                      :class="{'is-loading':isMainExpertStatusPending || isRejecting}"
                      v-text="$t('Отклонить (+тикет)')"
                      :disabled="!isMyDeCenter"
                    ></button>
                  </ws-role-node>

                  <ws-role-node :except="['front_mio', 'front_50plus', 'front_university']">
                    <button type="button" class="ws-button button is-danger is-small is-uppercase is-fullwidth"
                      v-if="getShowButton(buttonsNames.cancel)"
                      @click="changeMainExpertStatus(expertStatus.requested)"
                      :class="{'is-loading':isMainExpertStatusPending}"
                      v-text="$t('Отменить')"
                      :disabled="!isMyDeCenter"
                    ></button>
                  </ws-role-node>
              </ws-permission-node>
            </div>
          </div>
        </div>
      </div>
      <p v-else-if="showEmpty" class="has-text-grey">Эксперт не прикреплен</p>
    </template>
  </div>
</template>

<script>
import WsDemoExamsCertificateView from '../demo-exams/WsDemoExamsCertificateView.vue'
import expertStatus from '../demo-exams/data/expertStatusEnum'
import expertTypes from '../demo-exams/data/expertTypesEnum'
import buttonsNames from '../demo-exams/data/expertButtonsNames'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { get } from 'lodash'

const nullGuid = '00000000-0000-0000-0000-000000000000'

export default {
  name: 'WsMainExpertCard',
  components: { WsDemoExamsCertificateView },
  props: {
    expert: {
      type: Object,
      default: () => ({})
    },
    exam: {
      type: Object,
      default: () => ({})
    },
    isPending: {
      type: Boolean,
      default: false
    },
    isMyDeCenter: {
      type: Boolean,
      default: true
    },
    showEmpty: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isRemotePending: false,
      isRemote: null,
      expertStatus,
      expertTypes,
      buttonsNames,
      isRejecting: false,
      // isSaving: false,
      nullGuid
    }
  },
  computed: {
    ...mapState('authentication', ['currentRole']),
    ...mapState('exams', ['isMainExpertStatusPending']),
    ...mapState('examExtraRules', ['examRules']),
    isRemoteExam () {
      return this.exam.flags.indexOf('remote_experts') > -1
    },
    isSubmitDenied () {
      if (this.isDisableCheckDocs && ['front_curator', 'front_rcc'].includes(this.currentRole)) {
        return false
      }
      return (this.expert.main_expert_role_status !== 1) || (!this.isValidCertificate && !this.isValidAttestation && !['front_admin', 'front_dep'].includes(this.currentRole))
    },
    isValidCertificate () {
      const certificates = this.expert.certificates || []
      return certificates.some(i => moment(this.exam.ended_at).isBetween(i.issued_at, i.expired_at))
    },
    isValidAttestation () {
      const attestations = this.expert.attestations || []
      return attestations.some(i => moment(this.exam.ended_at).isBetween(i.issued_at, i.expired_at))
    },
    isDisableCheckDocs () {
      const examFlags = this.exam.flags || []
      const rulesFlags = [
        ...this.examRules.attestation_type,
        ...this.examRules.level_de
      ]

      const isDisableCheck = examFlags.every(flag => !rulesFlags.includes(flag))

      return isDisableCheck
    },
    disabledChangeMainExpertStatus () {
      if ((!this.isValidCertificate && !this.isValidAttestation) && ['front_curator', 'front_rcc'].includes(this.currentRole)) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('exams', ['update', 'updateMainExpert', 'deleteMainExpert', 'updateMainExpertStatus']),
    getShowButton (name) {
      const { expert_exam_status: expertExamStatus } = this.expert
      const isAccepted = expertExamStatus === expertStatus.accepted
      const isRejected = expertExamStatus === expertStatus.rejected
      const isRequested = expertExamStatus === expertStatus.requested

      switch (name) {
        case buttonsNames.assign:
          return !isAccepted && !isRejected && !this.isSubmitDenied
        case buttonsNames.appointment_unavailable:
          return this.isSubmitDenied && isRequested
        case buttonsNames.reject:
        case buttonsNames.reject_ticket:
          return !isAccepted && !isRejected
        case buttonsNames.cancel:
          return isAccepted
        default:
          return true
      }
    },
    async onRemoteChange (isRemote) {
      await this.setMainExpertIsRemote(isRemote)
    },
    async setMainExpertIsRemote (isRemote) {
      this.isRemotePending = true
      const body = { ...this.exam }
      if (isRemote) {
        body.flags = [...this.exam.flags, 'main_expert_is_remote']
      } else {
        body.flags = [...this.exam.flags]
        const isRemoteIndex = body.flags.indexOf('main_expert_is_remote')
        if (isRemoteIndex > -1) {
          body.flags.splice(isRemoteIndex, 1)
        }
      }
      await this.update([this.exam.guid, body])
      this.isRemotePending = false
    },
    async changeMainExpertStatus (status) {
      const mainExpert = await this.updateMainExpertStatus([this.exam.guid, status])
      if (mainExpert) {
        this.$emit('update', mainExpert)
      }
    },
    onMainExpertRejection () {
      this.mainExpertReject()
    },
    async mainExpertReject (body = '') {
      this.isRejecting = true
      await this.deleteMainExpert([this.exam.guid])
      const updatedExam = await this.updateMainExpertStatus([this.exam.guid, expertStatus.rejected, body])
      this.expert.expert_exam_status = updatedExam.main_expert && updatedExam.main_expert.expert_exam_status
      this.$emit('update', updatedExam)
      this.isRejecting = false
    },
    onMainExpertRejectionWithReason () {
      this.$buefy.dialog.prompt({
        title: this.$t('Причина отклонения'),
        message: this.$t(`Будет создано обращение в тикет системе от имени автора создания заявки. Автору заявки придёт уведомление с указанием причины отклонения`),
        confirmText: this.$t('Отправить'),
        cancelText: this.$t('Отмена'),
        inputAttrs: {
        },
        trapFocus: true,
        onConfirm: async (value) => {
          this.mainExpertReject({ reason: value })
        }
      })
    },
    getExpertName (isFullName = false) {
      const firstName = get(this.expert, 'first.display', '')
      const lastName = get(this.expert, 'last.display', '')
      const middleName = get(this.expert, 'middle.display', '')

      if (isFullName) {
        return `${lastName} ${firstName} ${middleName}`
      }
      return `${firstName} ${lastName}`
    }
  }
}
</script>

<style lang='scss' scoped>
.expert {
    &__loading {
      position: relative;
      min-height: 100px;
    }
}
</style>
